import {useState, useContext, useEffect, useRef} from "react";
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  CardHeader,
  Col,
  Row,
  Button,
  ButtonGroup,
} from "reactstrap";
import AppContext from "../../contexts/appContext";
import {createChart, updateChart} from "../../modules/callCharts";

import "../testing/media.css";
import {HOST_SERVICE} from "../../modules/bm";
import {CHART_COLORS} from "../../modules/helper";

const keepProps = (array) => {
  const firstObject = array && array.length > 0 ? array[0] : null;
  if (firstObject) {
    const props = Object.keys(firstObject);
    const filteredProps = props.filter(
      (prop) =>
        prop !== "category" &&
        prop !== "created" &&
        prop !== "instanceId" &&
        prop !== "userId" &&
        prop !== "total_measure" &&
        prop !== "total_rtt" &&
        prop !== "total_jitter" &&
        prop !== "total_loss" &&
        prop !== "total_legs" &&
        prop !== "total_ice" &&
        prop !== "count" &&
        prop !== "success" &&
        prop !== "warning" &&
        prop !== "_id" &&
        prop !== "__v" &&
        prop !== "rate" &&
        prop !== "countWithError"
    );
    return filteredProps;
  }
  return [];
};

function GlobalTrafficChart({dispatch}) {
  const appState = useContext(AppContext);
  const chartGlobalTraffic = useRef();
  const [series, setSeries] = useState([]);
  const [props, setProps] = useState([]); // To store the list of properties from services
  const [selectedProps, setSelectedProps] = useState("users");
  const [selectedSeries, setSelectedSeries] = useState([]);

  const CHART_MAIN_COLOR = {
    duration: CHART_COLORS.pink,
    users: CHART_COLORS.yellow,
    conferences: CHART_COLORS.blue,
    sent: CHART_COLORS.orange,
    received: CHART_COLORS.darkblue,
    traffic: CHART_COLORS.cyan,
    successRate: CHART_COLORS.orange,
  };

  const PROPSLABEL = {
    duration: "Daily Duration (in minutes)",
    traffic: "Daily Traffic (in MB)",
    users: "Daily Users (number)",
    conferences: "Daily Conferences (number)",
    sent: "Daily traffic sent (in MB)",
    received: "Daily traffic received (in MB)",
    successRate: "Daily success tate (in percent)",
  };

  const getLabels = (prop) => {
    switch (prop) {
      case "status":
        return ["", "success", "warning", "error", "unknown"];
      default:
        return null;
    }
  };

  const changeSeries = (selectedProps, series) => {
    if (series.length > 0) {
      const graphSeries = series.map((elt) => ({
        x: elt.created,
        y: elt[selectedProps],
      }));
      setSelectedSeries(graphSeries);
    }
  };

  const getButtonsList = (items) => {
    return items.map((item, index) => (
      <Button
        key={index}
        color="info"
        id="0"
        size="sm"
        tag="label"
        className={classNames("btn-simple", {
          active: selectedProps === item,
        })}
        onClick={() => {
          setSelectedProps(item);
        }}
      >
        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
          {item}
        </span>
        <span className="d-block d-sm-none">
          <i className="tim-icons icon-single-02"/>
        </span>
      </Button>
    ));
  };

  useEffect(() => {
    if (selectedSeries.length > 0) {
      updateChart(selectedSeries, null, chartGlobalTraffic, 2, 60000, true);
    }
  }, [selectedSeries]);

  useEffect(() => {
    changeSeries(selectedProps, series);
  }, [series]);

  useEffect(() => {
    createChart(
      document.querySelector("#chartGlobalTraffic"),
      chartGlobalTraffic,
      "MONTHLY",
      {
        prop: PROPSLABEL[selectedProps],
        colorProp: CHART_MAIN_COLOR[selectedProps],
        maxY: 60000,
        isLine: false,
        labels: getLabels(selectedProps),
        unit: "day",
      }
    );
    changeSeries(selectedProps, series);
  }, [selectedProps]);

  useEffect(() => {
    if (appState.summary && appState.summary.details) {
      setSeries(appState.summary.details);
      setProps(keepProps(appState.summary.details));
    }
  }, [appState.summary]);

  return (
    <Card className="card">
      <CardHeader>
        <Row>
          <Col className="text-left" sm="6">
            <h5 className="card-category">Cumulative traffic per day</h5>
            <CardTitle tag="h3">DAILY TRAFFIC</CardTitle>
          </Col>
          <Col className="text-left" sm="6">
            <ButtonGroup
              className="btn-group-toggle float-right"
              data-toggle="buttons"
            >
              {getButtonsList(props)}
            </ButtonGroup>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Row>
          <Col md="12">
            <div className="chart-container">
              <canvas id="chartGlobalTraffic"></canvas>
            </div>
          </Col>
        </Row>
      </CardBody>
      <CardFooter></CardFooter>
    </Card>
  );
}

export default GlobalTrafficChart;
